import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns the object keys for iteration in template
 */
@Pipe({ name: 'evObjectKeys',  pure: false })
export class ObjectKeysPipe implements PipeTransform {
  /**
   * Returns the object keys, to iterate in template
   *
   * @param value Value passed to this method via pipe in template
   * @param args Any additional arguments
   */
  public transform(value: any, args: Array<any> = null): any {
      return Object.keys(value);
  }
}
